export default function toSnakeCase(string) {
  return string
    .trim()
    .toLowerCase()
    .split(' ')
    .join('_');
}
